import {NgTemplateOutlet} from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {IconTileComponent} from '../icon-tile/icon-tile.component';

/**
 * White card with an icon tile, title and explanation.
 * - `split` (forms): title and explanation on the left (max 300px), the projected fields on the right in a grid.
 * - `stacked`: header row with optional `meta` text and `[actions]`, the body below.
 * `flush` removes the body padding, for lists that run to the card edges.
 */
@Component({
    selector: 'app-section',
    imports: [IconTileComponent, NgTemplateOutlet],
    templateUrl: './section.component.html',
    styleUrl: './section.component.scss',
    host: {
        '[class]': 'layout()',
        '[class.flush]': 'flush()',
        // `title` is an input; keep the browser from showing it as a tooltip on the whole element
        '[attr.title]': 'null',
        '[style.--ui-section-cols]': 'columns() ? "repeat(" + columns() + ", minmax(0, 1fr))" : null'
    }
})
export class SectionComponent {
    readonly layout = input<'split' | 'stacked'>('split');
    readonly icon = input<string>();
    readonly title = input<string>();
    readonly description = input<string>();
    readonly subtitle = input<string>();
    readonly meta = input<string | number | null>(null);
    readonly flush = input(false, {transform: booleanAttribute});
    /** Fixed number of field columns in the split layout; default fills columns of at least 220px. */
    readonly columns = input<number | null>(null);
}
